import { t } from "@lingui/core/macro"
import {
  Form,
  type LoaderFunctionArgs,
  type MetaFunction,
  redirect,
} from "react-router"
import { Logo } from "~/components/ui"
import { Button } from "~/components/ui/button"

export const meta: MetaFunction = () => {
  return [
    { title: t`Login - Loadpass.` },
    { name: "description", content: t`Login - Loadpass.` },
  ]
}

export const action = () => {
  throw redirect("/auth/auth0")
}

export const loader = ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)

  if (url.searchParams.has("origin")) {
    return null
  }

  throw redirect("/auth/auth0")
}

export default function Login() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-8">
      <header>
        <Logo />
      </header>
      <main>
        <Form method="post" className="m-0">
          <Button type="submit" size="lg">
            {t`Login`}
          </Button>
        </Form>
      </main>
    </div>
  )
}
